import React, { useState } from 'react'
import {
  Wrapper,
  InputWrapper,
  WrapperEmailAnswerIcon,
  WrapperBackButton
} from '../RecoverAccess.styles'
import {
  Button,
  ButtonEllipse,
  FontIcon,
  Input,
  Title,
  tokens
} from '@arvoreeducacao/bonsai-ds'
import { validateEmail } from 'utils/validations'
import { useHistory } from 'react-router-dom'
import { LOGIN_PATH, RECOVER_ACCESS_CONFIRM_SENT_PATH } from 'routes/paths'
import { useRequestPasswordResetMutation } from '__gql-generated__/types'

const EmailAnswer = () => {
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [emailLoading, setEmailLoading] = useState(false)
  const history = useHistory()

  const [requestPasswordReset] = useRequestPasswordResetMutation()

  const handleSubmit = async () => {
    if (email.length <= 0) return

    setEmailLoading(true)
    if (!validateEmail(email)) {
      setEmailError(true)
      setEmailLoading(false)
      return
    }

    await requestPasswordReset({ variables: { email } })

    setEmailLoading(false)

    history.push({
      pathname: RECOVER_ACCESS_CONFIRM_SENT_PATH,
      state: { email }
    })
  }

  const handleKeyUp: React.KeyboardEventHandler<HTMLInputElement> = ({
    key
  }) => {
    if (key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <Wrapper>
      <WrapperBackButton>
        <ButtonEllipse
          iconName="arrow-left"
          type="primary"
          onClick={() => {
            history.push(LOGIN_PATH)
          }}
          aria-label="Voltar para login"
        />
      </WrapperBackButton>
      <InputWrapper>
        <WrapperEmailAnswerIcon>
          <FontIcon iconName="mail" size={48} color={tokens.colors.black2} />
        </WrapperEmailAnswerIcon>
        <Title
          text="Qual o seu e-mail de acesso?"
          size={3}
          style={{ padding: '32px 0 24px', textAlign: 'center' }}
        />
        <Input
          label="Digite seu e-mail"
          type="email"
          value={email}
          onChange={e => {
            setEmail(e.target.value), setEmailError(false)
          }}
          error={emailError}
          helpText={emailError ? 'Por favor, insira um email válido' : ''}
          aria-label="Campo de email"
          onKeyUp={handleKeyUp}
        />
        <Button
          text="Avançar"
          onClick={handleSubmit}
          disabled={!email}
          loading={emailLoading}
          theme={{ type: 'primaryLivros', size: 'xLarge' }}
          fluid
          aria-label="Botão avançar"
        />
      </InputWrapper>
    </Wrapper>
  )
}

export default EmailAnswer
